import { Component, OnInit } from '@angular/core';
import { IServiceList, ServicesPageService } from './services-page.service';

@Component({
  selector: 'app-services-page',
  templateUrl: './services-page.component.html',
  styleUrls: ['./services-page.component.css']
})
export class ServicesPageComponent implements OnInit {
  public serviceList: IServiceList[]
  constructor(private servicesService: ServicesPageService) { }

  ngOnInit(): void {
    this.serviceList = this.servicesService.serviceList;
  }

}
